import axios from 'axios'
import url from './base-url';
const api = axios.create({
    baseURL: url
})
function Headers(auth){
    return {headers:{ 'x-access-token': auth,'Content-Type': 'application/json'}};
}
export const createPaymentIntent = (userId,payload,auth) => api.post(`/settings/createPaymentIntent/${userId}`,payload,Headers(auth));
export const createPaymentFromExistingAccount = (userId,payload,auth) => api.post(`/settings/createPaymentFromExisting/${userId}`,payload,Headers(auth));
export const addUserBalance = (userId, payload,auth) => api.post(`/settings/userBalance/${userId}`,payload,Headers(auth));
export const getUserLatestBalance = (userId,auth) => api.get(`/settings/userlatestBalance/${userId}`,Headers(auth));
export const stripeCardList = (userId,auth) => api.get(`/settings/userCardList/${userId}`,Headers(auth));
export const getStripeCustomerInfo = (stripeCustomerId,auth)=> api.get(`/settings/stripeCustomer/${stripeCustomerId}`,Headers(auth));
export const addCredit = (userId,payload,auth) =>api.post(`/setttings/addCredit/${userId}`,payload,Headers(auth));
const apis = {
    createPaymentIntent,
    addUserBalance,
    getUserLatestBalance,
    stripeCardList,
    getStripeCustomerInfo,
    createPaymentFromExistingAccount,
    addCredit
};

export default apis;